import React from "react"
import DynamicInputs from "@components/objects/DynamicInputs/DynamicInputs"

const FormFAQ = ({ data, handleChangeDynamic }) => (
  <section>
    <div>
      <h3>FAQ's</h3>
      <p>
        Your answers to the questions below will help show your personality and give a sense of what
        it's like working with you and your business. The below questions are just a guide - feel
        free to write your own.
      </p>
      <ol>
        <li>Describe the best party / wedding you were involved with?</li>
        <li>What is your number one top tip?</li>
        <li>Describe your style in 3 words</li>
        <li>Have you organised any celebrity or VIP parties or weddings?</li>
        <li>What’s your favourite late night bite?</li>
        <li>What’s your USP?</li>
      </ol>
      <DynamicInputs
        handlechange={(e) => handleChangeDynamic(e, "faqs")}
        buttonLabel="Add Question"
        stateName="faqs"
        title="FAQ's"
        className="dynamic-input"
        value={data.faqs.map((el) => el.attributes)}
        inputFields={[
          {
            className: "questiontext",
            label: "Question",
            inputType: "text",
          },
          {
            className: "answertext",
            label: "Answer",
            inputType: "textarea",
          },
        ]}
      />
    </div>
  </section>
)

export default FormFAQ
